export default "__VITE_ASSET__BImxTkqL__"